import React, { Component,Fragment } from 'react';
import LoginForm from "../../components/admin/loginForm";
import Header from "../../components/admin/header";
import { AdminAuthentication } from "../../utils/authentication";
import ResponsiveAppBar from '../../components/components/appbar';
import ResponsiveFooter from '../../components/components/footer';

class AdminLogin extends Component {
    constructor(props: any) {
        super(props);
        AdminAuthentication();

    }
    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
            <div className="pageHeight">
                <Header />
                <LoginForm history={window.history} />
            </div>
            <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default AdminLogin;